import { render, staticRenderFns } from "./claim_table.vue?vue&type=template&id=03dc35ec&scoped=true"
import script from "./claim_table.vue?vue&type=script&lang=js"
export * from "./claim_table.vue?vue&type=script&lang=js"
import style0 from "./claim_table.vue?vue&type=style&index=0&id=03dc35ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc35ec",
  null
  
)

export default component.exports